export const entity = {
    name: "ColleagueFile",
    type: "mongoInternal",
    fields: [
        {path: "filename"},
        {path: "date"},
        {path: "user", type: "object"},
        {path: "password"},
        {path: "tags", list: true, type: "object", nullable: true},
    ]
};
